module.exports = __webpack_public_path__ + "static/media/hubtricity-dashboard-logo.3e133c62.png";